import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '@app/core/services/spinner.service';

@Component({
  selector: 'app-abc-spinner',
  templateUrl: './abc-spinner.component.html',
  styleUrls: ['./abc-spinner.component.scss'],
})
export class AbcSpinnerComponent implements OnInit {
  constructor(private readonly spinnerService: SpinnerService) {}

  loadingText: string | null = null;

  ngOnInit(): void {
    this.loadingText = this.spinnerService.loadingText();
    // Empty Init
  }
}
